import React from 'react';
import { getHotels, deleteRoomType, updateRoomType, createRoomType, RoomType, Hotel } from '../api/hotels.ts';
import http from '../api/http.ts';

export default function RoomsPage(){
  const [hotelId, setHotelId] = React.useState<number | ''>('');
  const [hotels, setHotels] = React.useState<{ id:number; name:string }[]>([]);
  const [roomTypes, setRoomTypes] = React.useState<RoomType[]>([]);
  const [draft, setDraft] = React.useState<Partial<RoomType>>({ name:'', basePrice:0, capacityAdults:2, capacityChildren:0, bedType:'QUEEN' });
  const [edits, setEdits] = React.useState<Record<number, Partial<RoomType>>>({});

  React.useEffect(()=>{ (async()=>{ try{ const list: Hotel[] = await getHotels(); setHotels((list||[]).filter(h=>h.id!=null).map(h=>({ id: h.id as number, name: h.name })) ); }catch{} })(); },[]);
  React.useEffect(()=>{ (async()=>{ if(!hotelId) return; try{ const rows = await http.get(`/api/v1/admin/hotels/${hotelId}/room-types`); setRoomTypes(Array.isArray(rows)?rows:[]); }catch{ setRoomTypes([]);} })(); },[hotelId]);

  const save = async () => {
    if(!hotelId || !draft.name) return;
    await createRoomType(Number(hotelId), { name: draft.name!, basePrice: Number(draft.basePrice||0), capacityAdults: Number(draft.capacityAdults||2), capacityChildren: Number(draft.capacityChildren||0), bedType: draft.bedType||'QUEEN' });
    // Force reload list after creation
    const rows = await http.get(`/api/v1/admin/hotels/${hotelId}/room-types?_=${Date.now()}`);
    setRoomTypes(Array.isArray(rows)?rows:[]);
    setDraft({ name:'', basePrice:0 });
  };

  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ marginBottom: 12 }}>Hotel Rooms</h2>
      <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:12 }}>
        <select aria-label="Select hotel" value={hotelId} onChange={(e)=> setHotelId(Number(e.target.value) as any)} style={{ minWidth:220 }}>
          <option value="" disabled>Select hotel…</option>
          {hotels.map(h => (<option key={h.id} value={h.id}>{h.name}</option>))}
        </select>
      </div>

      {hotelId && (
        <div>
          <div style={{ border:'1px solid #ddd', padding:12, marginBottom:12, display:'flex', gap:8, alignItems:'center' }}>
            <input placeholder="Room name" value={draft.name||''} onChange={e=> setDraft(d=>({ ...d, name:e.target.value }))} />
            <input placeholder="Base price" type="number" value={draft.basePrice as any} onChange={e=> setDraft(d=>({ ...d, basePrice:Number(e.target.value) }))} />
            <button onClick={save}>Add</button>
          </div>

          {roomTypes.length === 0 ? (
            <div>No room types yet.</div>
          ) : (
            roomTypes.map(rt => (
              <div key={rt.id} style={{ border:'1px solid #ddd', padding:12, marginBottom:8, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <div>
                  <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                    <input aria-label="Room type name" value={(edits[rt.id!]?.name ?? rt.name) as any} onChange={e=> setEdits(v=>({ ...v, [rt.id!]: { ...v[rt.id!], name: e.target.value } }))} />
                    <input aria-label="Base price" type="number" value={(edits[rt.id!]?.basePrice ?? rt.basePrice) as any} onChange={e=> setEdits(v=>({ ...v, [rt.id!]: { ...v[rt.id!], basePrice: Number(e.target.value||0) } }))} style={{ width:100 }} />
                    <select aria-label="Bed type" value={(edits[rt.id!]?.bedType ?? rt.bedType) as any} onChange={e=> setEdits(v=>({ ...v, [rt.id!]: { ...v[rt.id!], bedType: e.target.value as any } }))}>
                      {['QUEEN','KING','TWIN','DOUBLE'].map(b=> <option key={b} value={b}>{b}</option>)}
                    </select>
                    <input aria-label="Adults" type="number" value={(edits[rt.id!]?.capacityAdults ?? rt.capacityAdults ?? 2) as any} onChange={e=> setEdits(v=>({ ...v, [rt.id!]: { ...v[rt.id!], capacityAdults: Number(e.target.value||0) } }))} style={{ width:70 }} />
                    <input aria-label="Children" type="number" value={(edits[rt.id!]?.capacityChildren ?? rt.capacityChildren ?? 0) as any} onChange={e=> setEdits(v=>({ ...v, [rt.id!]: { ...v[rt.id!], capacityChildren: Number(e.target.value||0) } }))} style={{ width:70 }} />
                  </div>
                </div>
                <div style={{ display:'flex', gap:6 }}>
                  <button onClick={async ()=>{
                    const d = edits[rt.id!] || {};
                    await updateRoomType(Number(hotelId), Number(rt.id), { name: (d.name ?? rt.name)!, basePrice: (d.basePrice ?? rt.basePrice)!, capacityAdults: d.capacityAdults ?? rt.capacityAdults ?? 2, capacityChildren: d.capacityChildren ?? rt.capacityChildren ?? 0, bedType: (d.bedType ?? rt.bedType) || 'QUEEN' });
                    const rows = await http.get(`/api/v1/admin/hotels/${hotelId}/room-types?_=${Date.now()}`); setRoomTypes(Array.isArray(rows)?rows:[]); setEdits(v=> ({ ...v, [rt.id!]: {} }));
                  }}>Save</button>
                  <button onClick={async ()=>{ await deleteRoomType(Number(hotelId), Number(rt.id)); const rows = await http.get(`/api/v1/admin/hotels/${hotelId}/room-types?_=${Date.now()}`); setRoomTypes(Array.isArray(rows)?rows:[]); }}>Delete</button>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}


